import Box from "@mui/material/Box"
import { Container, ThemeProvider } from "@mui/material"

import { theme } from "@ikhokha/commons-ui"

import "./styles.css"

export default function MainWrapper({
	child,
	childFooter,
	isSmallScreen,
}: {
	child: any
	childFooter: any
	isSmallScreen: boolean
}) {
	return (
		<ThemeProvider theme={theme}>
			<Box className="app">
				<Container
					sx={
						isSmallScreen
							? {
									width: "100%",
									flexGrow: 1,
									paddingLeft: "0px",
									paddingRight: "0px",
									maxWidth: {
										lg: "100%",
										md: "md",
										sm: "sm",
										xs: "xs",
									},
							  }
							: {
									flexGrow: 1,
									paddingLeft: "0px",
									paddingRight: "0px",
									maxWidth: {
										lg: "100%",
										md: "md",
										sm: "sm",
										xs: "xs",
									},
							  }
					}
				>
					{child}
				</Container>
				{childFooter}
			</Box>
		</ThemeProvider>
	)
}
